import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "q-pa-xs" };
const _hoisted_2 = { class: "q-pa-xs col-xs-12 col-sm-6 col-md-4 col-lg-3 grid-style-transition" };
const _hoisted_3 = { class: "q-table__grid-item-row" };
const _hoisted_4 = { class: "q-table__grid-item-title" };
const _hoisted_5 = { class: "q-table__grid-item-value" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_inner_loading = _resolveComponent("q-inner-loading");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_table = _resolveComponent("q-table");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_table, {
            rows: _ctx.data.items,
            columns: _ctx.columns,
            "rows-per-page-options": "0",
            "row-key": "shomeiNo",
            onRowClick: _ctx.onRowClick,
            loading: _ctx.loading,
            "hide-bottom": _ctx.data.items.length > 0,
            grid: _ctx.$q.screen.xs,
            "binary-state-sort": "",
            "no-data-label": "申請済みのデータがありません。"
        }, {
            loading: _withCtx(() => [
                _createVNode(_component_q_inner_loading, {
                    showing: "",
                    color: "primary"
                })
            ]),
            item: _withCtx((props) => [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_q_card, {
                        class: "q-table__grid-item-card q-table__card cursor-pointer",
                        onClick: ($event) => (_ctx.onCardClick(props))
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: col.name,
                                    class: "q-item-type row no-wrap"
                                }, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("span", _hoisted_4, _toDisplayString(col.label + " ： "), 1),
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(col.value), 1)
                                    ])
                                ]));
                            }), 128))
                        ]),
                        _: 2
                    }, 1032, ["onClick"])
                ])
            ]),
            _: 1
        }, 8, ["rows", "columns", "onRowClick", "loading", "hide-bottom", "grid"])
    ]));
}
